import { Button, Checkbox, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionProperties extends Layout {
    checkboxEmail: Checkbox;
    checkboxFax: Checkbox;
    checkboxFtp: Checkbox;
    checkboxLogix: Checkbox;
    checkboxPrint: Checkbox;
    panelEmailProperties: Panel;
    panelMainProps: Panel;
    panelPrintProps: Panel;
    pbPortalDefs: Button;
    pbRendProfiles: Button;
    sourceRendDocumentProfiles: DataSource;
    sourceRendOverrideProfiles: DataSource;
    sourceRenditionEmailProfiles: DataSource;
    sourceRenditionFaxProfiles: DataSource;
    sourceRenditionFtpProfiles: DataSource;
    sourceRenditionLogixProfiles: DataSource;
    sourceRenditionProperties: DataSource;
    sourceRenditionRuleProfiles: DataSource;
    sourceRenditionTypes: DataSource;
    tabEmail: Tab;
    tabFTP: Tab;
    tabFax: Tab;
    tabLogix: Tab;
    tabPrint: Tab;
    tabsetProperties: Tabset;
    textboxDocpId: Textbox;
    textboxEmailpId: Textbox;
    textboxFaxpId: Textbox;
    textboxFtppId: Textbox;
    textboxOvrhDesc: Textbox;
    textboxOvrhId: Textbox;
    textboxRenpDocid: Textbox;
    textboxRenpDuplex: Checkbox;
    textboxRenpEmailaddr: Textbox;
    textboxRenpEmaildocid: Textbox;
    textboxRenpEmailid: Textbox;
    textboxRenpEmailmaxsz: Textbox;
    textboxRenpEmailruleid: Textbox;
    textboxRenpFaxdocid: Textbox;
    textboxRenpFaxid: Textbox;
    textboxRenpFaxname: Textbox;
    textboxRenpFaxnum: Textbox;
    textboxRenpFaxruleid: Textbox;
    textboxRenpFormoverlay: Textbox;
    textboxRenpFtpdocid: Textbox;
    textboxRenpFtpfldrname: Textbox;
    textboxRenpFtphost: Textbox;
    textboxRenpFtpid: Textbox;
    textboxRenpFtpmode: Textbox;
    textboxRenpFtpruleid: Textbox;
    textboxRenpFtptype: Textbox;
    textboxRenpId: Textbox;
    textboxRenpLogin: Textbox;
    textboxRenpName: Textbox;
    textboxRenpOvrid2: Textbox;
    textboxRenpOvrid: Textbox;
    textboxRenpPort: Textbox;
    textboxRenpPrintdocid: Textbox;
    textboxRenpPrintruleid: Textbox;
    textboxRenpProcess: Checkbox;
    textboxRenpPwd: Textbox;
    textboxRenpRuleid: Textbox;
    textboxRenpStaple: Checkbox;
    textboxRenpTlsmode: Textbox;
    textboxRenpTypeid2: Textbox;
    textboxRenpTypeid: Textbox;
    textboxRenpXdocid: Textbox;
    textboxRenpXid: Textbox;
    textboxRenpXruleid: Textbox;
    textboxRulepId: Textbox;
    textboxTypepDesc: Textbox;
    textboxTypepId: Textbox;
}
